import { render, staticRenderFns } from "./FuzzySwitch.vue?vue&type=template&id=46d89550&scoped=true&"
import script from "./FuzzySwitch.vue?vue&type=script&lang=js&"
export * from "./FuzzySwitch.vue?vue&type=script&lang=js&"
import style0 from "./FuzzySwitch.vue?vue&type=style&index=0&id=46d89550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d89550",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VContainer,VSwitch})
